export const en = {
  nav: {
    home: 'Home',
    treatments: 'Treatments',
    results: 'Results',
    gallery: 'Gallery',
    compare: 'Compare',
    blog: 'Blog',
    locations: 'Locations',
    contact: 'Contact',
    bookConsultation: 'Book Free Consultation',
    hairAnalysis: 'AI Hair Analysis',
  },
  hairTransplant: {
    title: 'FUE Hair Transplant',
    subtitle: 'Advanced Follicular Unit Extraction designed to support natural-looking, long-lasting results. Individual outcomes vary.',
    bookConsultation: 'Book Free Consultation',
    viewResults: 'View Results',
    benefits: 'Why Choose FUE Hair Transplant?',
    process: 'The FUE Procedure Step by Step',
    pricing: 'Transparent Pricing Packages',
    stats: 'Our Results',
  },
  stemcellTherapy: {
    title: 'Stemcell Therapy',
    subtitle: 'Informational overview of stem cell research in hair restoration. Availability depends on medical assessment and applicable local regulations.',
    benefits: 'Benefits of Stem Cell Therapy',
    howItWorks: 'How It Works',
    pricing: 'Stem Cell Therapy Packages',
    idealFor: 'Who Should Consider Stem Cell Therapy?',
  },
  prp: {
    title: 'PRP Hair Treatment',
    subtitle: 'Platelet-Rich Plasma therapy to stimulate natural hair growth',
    whatIs: 'What is PRP Hair Treatment?',
    benefits: 'Benefits of PRP Treatment',
    procedure: 'The PRP Procedure',
    packages: 'PRP Treatment Packages',
    results: 'When to Expect Results',
    idealFor: 'Who Should Consider PRP?',
  },
  hero: {
    title: 'Expert Hair Transplants in Europe',
    subtitle: 'Turkish surgical expertise combined with European aftercare standards. The partner clinic’s team performs FUE and DHI hair restoration procedures. Individual results vary and depend on suitability, technique, and aftercare.',
    bookConsultation: 'Book Free Consultation',
    whatsapp: 'WhatsApp Us',
  },
  services: {
    title: 'Our Premium Hair Restoration Services',
    subtitle: 'Advanced techniques combining Turkish expertise with European quality standards',
  },
  results: {
    title: 'Patient Examples and Expected Timelines',
    subtitle: 'Illustrative examples from previous patients. Individual results vary and depend on donor area, hair loss pattern, health, technique, and aftercare.',
  },
  locations: {
    title: 'Convenient Locations Across Europe',
    subtitle: 'Premium care in state-of-the-art facilities',
  },
  contact: {
    title: 'Start Your Hair Restoration Journey',
    subtitle: 'Book your free consultation today',
    name: 'Full Name',
    email: 'Email',
    phone: 'Phone Number',
    treatment: 'Interested In',
    message: 'Tell us about your hair loss concerns',
    send: 'Send Message',
    sending: 'Sending...',
  },
  footer: {
    about: 'Hair Art Clinics combines Turkish medical excellence with European quality standards, offering premium hair restoration services via our partner clinic in Turkey, with advice from Den Haag, the Netherlands.',
    quickLinks: 'Quick Links',
    contactInfo: 'Contact Information',
    followUs: 'Follow Us',
    rights: 'All rights reserved.',
  },
  treatments: {
    categories: {
      hairTransplant: 'Hair Transplant Techniques',
      facialHair: 'Facial Hair Restoration',
      revision: 'Revision & Correction',
      nonSurgical: 'Non-Surgical Treatments',
      additional: 'Additional Services',
      guides: 'Information & Guides'
    },
    bookConsultation: 'Book Free Consultation',
    benefits: 'Benefits',
    procedure: 'Procedure',
    recovery: 'Recovery Timeline',
    pricing: 'Pricing',
    faq: 'Frequently Asked Questions',
    contraindications: 'Contraindications',
    beforeAfter: 'Before & After Results',
    before: 'Before',
    after: 'After',
    bookingSubtitle: 'Schedule your free consultation with our experts',
    preferredDate: 'Preferred Date',
    selectDate: 'Select a date',
    bookingMessage: 'Tell us about your hair concerns and unknown questions you have',
    submitBooking: 'Submit Booking Request',
    bookingSuccess: 'Thank you! We will contact you shortly to confirm your appointment.',
    category: 'Treatment Categories',
    all: 'All Treatments',
    gallery: 'Before/After Gallery',
    resultsTitle: 'Our Real Results',
    resultsSubtitle: 'Discover transformation stories of thousands of our happy patients',
    patientStories: 'Patient Stories',
    viewDetails: 'View Details',
    grafts: 'grafts',
    age: 'Age',
    testimonial: 'Patient Testimonial',
    allResults: 'All Results',
    filterByProcedure: 'Filter by Procedure'
  },
  comparison: {
    title: 'FUE vs DHI vs Sapphire FUE',
    subtitle: 'Compare hair transplant techniques to find the perfect method for you',
    compareTitle: 'Technique Comparison',
    method: 'Method',
    duration: 'Procedure Duration',
    recovery: 'Recovery Time',
    scarring: 'Scarring',
    density: 'Hair Density',
    pain: 'Pain Level',
    cost: 'Cost Range',
    bestFor: 'Best For',
    fue: {
      name: 'FUE',
      duration: '6-8 hours',
      recovery: '7-10 days',
      scarring: 'Minimal micro-dots',
      density: 'High',
      pain: 'Low (local anesthesia)',
      cost: '€2,500 - €4,500',
      bestFor: 'Large areas, maximum grafts'
    },
    dhi: {
      name: 'DHI',
      duration: '8-10 hours',
      recovery: '5-7 days',
      scarring: 'Virtually none',
      density: 'Very High',
      pain: 'Minimal',
      cost: '€3,500 - €5,500',
      bestFor: 'Precision work, hairline design'
    },
    sapphire: {
      name: 'Sapphire FUE',
      duration: '6-8 hours',
      recovery: '5-7 days',
      scarring: 'Minimal',
      density: 'Very High',
      pain: 'Low',
      cost: '€3,000 - €5,000',
      bestFor: 'Natural results, faster healing'
    },
    advantages: 'Key Advantages',
    disadvantages: 'Considerations',
    faqTitle: 'Frequently Asked Questions'
  },
  blog: {
    title: 'Hair Care & Wellness Blog',
    subtitle: 'Expert insights, treatment information, and patient success stories',
    categories: {
      all: 'All Articles',
      hairHealth: 'Hair Health',
      treatmentInfo: 'Treatment Information',
      patientStories: 'Patient Stories',
      clinicGuides: 'Clinic Guides',
      procedures: 'Procedures'
    },
    readMore: 'Read full article',
    backToBlog: 'Back to Blog',
    recentPosts: 'Recent Posts',
    relatedPosts: 'Related Articles',
    publishedOn: 'Published on',
    by: 'by',
    views: 'views',
    noPostsFound: 'No articles found',
    searchPlaceholder: 'Search articles...',
    admin: {
      title: 'Blog Management',
      newPost: 'New Article',
      editPost: 'Edit Article',
      deletePost: 'Delete Article',
      published: 'Published',
      draft: 'Draft',
      title_label: 'Title',
      slug_label: 'URL Slug',
      category_label: 'Category',
      excerpt_label: 'Excerpt',
      content_label: 'Content',
      featuredImage_label: 'Featured Image URL',
      isPublished_label: 'Publish',
      save: 'Save Article',
      cancel: 'Cancel',
      deleteConfirm: 'Are you sure you want to delete this article?',
      viewOnSite: 'View on Site'
    }
  },
  error: "Error",
  success: "Success",
  admin: {
    dashboard: 'Admin Dashboard',
    overview: 'Overview and management',
    whatsapp: 'WhatsApp',
    liveSupport: 'Live Support',
    leadManagement: 'Lead Management',
    blogManagement: 'Blog Management',
    calendarView: 'Calendar View',
    gtmSetup: 'GTM Setup',
    totalBookings: 'Total Bookings',
    pending: 'Pending',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    patientResults: 'Patient Results',
    published: 'Published',
    thisMonth: 'This Month',
    newBookings: 'New bookings',
    bookingTrend: 'Booking Trend (Last 6 Months)',
    monthlyStats: 'Monthly booking statistics',
    bookingStatus: 'Booking Status',
    statusDistribution: 'Distribution by status',
    popularTreatments: 'Popular Treatments',
    topTreatments: 'Top 5 most requested treatments',
    patientResultsManagement: 'Patient Results Management',
    manageBeforeAfter: 'Manage before/after images and testimonials',
    addNewResult: 'Add New Result',
    editResult: 'Edit Patient Result',
    patientName: 'Patient Name',
    age: 'Age',
    procedureType: 'Procedure Type',
    graftsCount: 'Grafts Count',
    surgeryDate: 'Surgery Date',
    displayOrder: 'Display Order',
    beforeImage: 'Before Image',
    afterImage: 'After Image',
    keepCurrentImage: 'Leave empty to keep current image',
    testimonial: 'Testimonial',
    doctorNotes: 'Doctor Notes',
    publishImmediately: 'Publish immediately',
    cancel: 'Cancel',
    uploading: 'Uploading...',
    update: 'Update',
    create: 'Create',
    unpublish: 'Unpublish',
    publish: 'Publish',
    draft: 'Draft',
    surgery: 'Surgery',
    order: 'Order',
    noResults: 'No patient results yet. Add your first one!',
    deleteConfirm: 'Are you sure you want to delete this result?',
    // Leads
    leads: 'Lead Management',
    trackLeads: 'Track your potential customers',
    downloadCSV: 'Download CSV',
    totalLeads: 'Total Leads',
    hot: 'Hot',
    warm: 'Warm',
    cold: 'Cold',
    converted: 'Converted',
    sourceReport: 'Source Report',
    conversions: 'conversions',
    searchPlaceholder: 'Search by email, phone or name...',
    allStatuses: 'All Statuses',
    new: 'New',
    contacted: 'Contacted',
    qualified: 'Qualified',
    lost: 'Lost',
    allSources: 'All Sources',
    filterSource: 'Filter by source',
    leadList: 'Lead List',
    loading: 'Loading...',
    noLeads: 'No leads found',
    contact: 'Contact',
    source: 'Source',
    score: 'Score',
    activities: 'Activities',
    status: 'Status',
    date: 'Date',
    actions: 'Actions',
    pageViews: 'Page Views',
    formSubmissions: 'Form Submissions',
    pdfDownloads: 'PDF Downloads',
    chatInteractions: 'Chat Interactions',
    leadDetail: 'Lead Detail',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    utmParams: 'UTM Parameters',
    notes: 'Notes',
    saveNotes: 'Save Notes',
    recentActivities: 'Recent Activities',
    delete: 'Delete',
    deleteLeadConfirm: 'Are you sure you want to delete this lead?',
    initialEmail: 'Initial Contact Email',
    followUpEmail: 'Follow Up Email',
    call: 'Call',
    manualEmail: 'Manual Email',
    // Calendar
    bookingsCalendar: 'Bookings Calendar',
    viewManageAppointments: 'View and manage all appointments',
    sendReminders: 'Send Reminders',
    searchByNameEmailPhone: 'Search by name, email, or phone...',
    filterByStatus: 'Filter by status',
    allTreatments: 'All Treatments',
    clearFilters: 'Clear Filters',
    today: 'Today',
    more: 'more',
    selectDate: 'Select a date',
    noBookingsForDate: 'No bookings for this date',
    clickToView: 'Click on a date to view bookings',
    reminded: 'Reminded',
    confirm: 'Confirm',
    accessDenied: 'Access Denied',
    needAdminAccess: 'You need admin privileges to access this page.',
    goHome: 'Go Home',
    // Gallery
    galleryManagement: 'Gallery Management',
    backToGallery: 'Back to Gallery',
    uploadNewPhoto: 'Upload New Photo',
    title: 'Title',
    description: 'Description',
    altText: 'Alt Text (important for SEO)',
    treatmentPage: 'Treatment Page (Optional)',
    selectTreatment: 'Select a treatment (can be left empty)',
    treatmentNote: 'Select a treatment to show this photo on that treatment page. Leave empty for general gallery only.',
    photo: 'Photo',
    upload: 'Upload',
    uploadedPhotos: 'Uploaded Photos',
    removeFromPublish: 'Unpublish',
    generalGallery: 'General Gallery (No treatment)',
    // Email Templates
    emailTemplates: 'Email Templates',
    manageEmailTemplates: 'Manage automated email templates',
    newTemplate: 'New Template',
    templateKey: 'Key',
    active: 'Active',
    preview: 'Preview',
    edit: 'Edit',
    editTemplate: 'Edit Template',
    templateName: 'Template Name',
    emailSubject: 'Email Subject',
    htmlContent: 'HTML Content',
    variablesNote: 'Variables: {{name}}, {{email}} can be used',
    save: 'Save',
    close: 'Close',
    createTemplate: 'Create Template',
    templateKeyUnique: 'Template Key (unique)',
    // CMS
    cms: 'Content Management',
    posts: 'Posts',
    pages: 'Pages',
    media: 'Media',
    categories: 'Categories',
    settings: 'Settings',
  },
  hairAnalysis: {
    title: "AI Hair Analysis",
    subtitle: "Upload your photo for an AI-based preliminary hair assessment. This is an initial screening tool and does not replace consultation with a qualified clinician.",
    uploadPhoto: "Upload Photo",
    uploadPhotoDesc: "Upload a clear photo of your hair for analysis",
    clickToUpload: "Click to upload image",
    analyzeNow: "Analyze Now",
    analyzing: "Analyzing...",
    analysisResults: "Analysis Results",
    hairLossStage: "Hair Loss Stage",
    estimatedGrafts: "Estimated Grafts",
    recommendedTreatment: "Recommended Treatment",
    recommendations: "Recommendations",
    detailedAnalysis: "Detailed Analysis",
    howItWorks: "How It Works",
    step1: "Upload a clear front-facing photo of your hair",
    step2: "Our AI analyzes your hair density and loss pattern",
    step3: "Receive instant assessment with treatment recommendations",
    step4: "Book a consultation with our specialists for detailed planning",
    priceEstimate: "Estimated Price",
    pricePerGraft: "Price per graft",
    priceNote: "* Final price will be determined during consultation",
    priceRange: 'Estimated Price Range',
    bookViaWhatsApp: 'Book via WhatsApp',
    whatsappMessage: 'WhatsApp Consultation',
    getDetailedReport: 'Get Detailed PDF Report',
    reportDescription: 'Receive a comprehensive analysis report with treatment recommendations via email',
    yourName: 'Your Name',
    yourEmail: 'Your Email',
    enterName: 'Enter your name',
    enterEmail: 'Enter your email address',
    sendReport: 'Send Report to Email',
    sending: 'Sending...',
    reportDisclaimer: 'Free detailed PDF report with treatment plan and pricing',
    shareResults: 'Share Your Results',
    shareDescription: 'Share your analysis results with friends and family',
    shareNote: '* Instagram: Text will be copied to clipboard',
  },
  auth: {
    seoTitle: 'Login & Sign Up - Patient Portal Access | Hair Art Clinics',
    seoDescription: 'Access your Hair Art Clinics patient portal. Sign in to view medical records, treatment photos and manage appointments.',
    welcome: 'Welcome',
    welcomeSubtitle: 'Sign in to access the patient portal or create a new account',
    forgotTitle: 'Forgot Password',
    forgotSubtitle: 'Enter your email to receive a reset link',
    resetTitle: 'Reset Password',
    resetSubtitle: 'Enter your new password',
    login: 'Login',
    signup: 'Sign Up',
    email: 'Email',
    password: 'Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    signIn: 'Sign In',
    createAccount: 'Create Account',
    updatePassword: 'Update Password',
    sendResetLink: 'Send Reset Link',
    backToLogin: 'Back to Login',
    orContinueWith: 'Or continue with',
    continueWithGoogle: 'Continue with Google',
    forgotYourPassword: 'Forgot your password?',
  },
  clinic: {
    city: 'Den Haag',
    country: 'Netherlands',
    region: 'South Holland',
    hoursLabel: 'Opening hours',
    hoursDaily: 'Every day',
  },
};
